export default __webpack_public_path__ + "a3394a840c938426b8b25bc74a5f6833.png";